import { FiltroBuscarCliente } from '../filtro/filtro-buscar-cliente';

export class RedireccionMenu {

    url: String;
    isLocal: boolean;
    isLogout: boolean;
    opcionVenta: String;
    filtroBuscarCliente: FiltroBuscarCliente;
    contextPath: string;
    codigoProducto: String;
    tipoDocumento: String;

    constructor(url: String, isLocal: boolean, isLogout: boolean, opcionVenta: String, contextPath: string, codigoProducto: String, 
    tipoDocumento: String) {
        this.url = url;
        this.isLocal = isLocal;
        this.isLogout = isLogout;
        this.opcionVenta = opcionVenta;
        this.contextPath = contextPath;
        this.codigoProducto = codigoProducto;
        this.tipoDocumento = tipoDocumento;
    }



}



// WEBPACK FOOTER //
// ./src/app/models/menu/redireccion-menu.class.ts